// extracted by mini-css-extract-plugin
export var wrapper = "video-embed-block-module--wrapper--58e8f";